import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Stack,
  InputLabel,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Card,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { vehicleCategoriesActions } from "../../service/vehicleCategories.actions";
import "../vehicleCategories/vehicleCategories.css";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileSaver from "file-saver";
import { v4 as uuid } from "uuid";
import { Edit } from "@mui/icons-material";
import VehicleCategoriesModal from "./VehicleCategoriesModal";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../util/component/CustomLoader";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { IServerSideGetRowsParams } from "ag-grid-community";
import GenericFilterBox from "../common/GenericFilterBox";
import { GenericTitleHeader } from "../common/GenericTitleHeader";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

const VehicleCategoriesTable = () => {
  const [pageSize, setPageSize] = useState<number>(10);
  const [length, setLength] = useState<number>(0);
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [loading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const { dispatchGlobalData } = useContext(GlobalContext);

  const [dataForm, setData] = useState<any>({
    carClassDescription: "",
    carSegmentDescription: "",
    acrissCode: "",
    customAcrissCode: "",
  });
  const {tenant} = useContext(ContextOperation);
 
  const params: any = {};
  for (const key of Object.keys(dataForm)) {
    if (dataForm[key] !== "") {
      params['tenant'] =tenant;
	  
      if(typeof dataForm[key] === 'string'){
        params[key] = dataForm[key].trim();
      } else {
        params[key] = dataForm[key];
      }
    }
  }

  const { t } = useTranslation(["operation"]);
  const vehicleCategoriesActionss = vehicleCategoriesActions();
  const columns: any = [
    {
      field: "carSegmentOrder",
      headerName: t("vehicleCategory.order"),
      flex:0.7
    },
    {
      field: "carSegmentDescr",
      headerName: t("vehicleCategory.carSegment"),
      flex: 1,
    },
    {
      field: "carClassDescr",
      headerName: t("vehicleCategory.carClassTabel"),
      flex: 0.8,
    },

    {
      field: "acrissCode",
      headerName: t("vehicleCategory.acrissCode"),
      flex: 0.7,
    },
    {
      field: "acrissLabel",
      headerName: t("vehicleCategory.acrissLabel"),
      flex: 1,
      cellRenderer: (record: any) => (
        <Tooltip title={record.data.acrissLabel}>
          <span>{record.data.acrissLabel}</span>
        </Tooltip>
      ),
    },
    {
      field: "acrissVehicleType",
      headerName: t("vehicleCategory.acrissVehicleType"),
      flex: 1.4,
    },
    {
      field: "customAcrissCode",
      headerName: t("vehicleCategory.customAcrissCode"),
      flex: 0.7,
    },
    {
      field: "customAcrissLabel",
      headerName: t("vehicleCategory.customAcrissLabel"),
      flex: 1,
      cellRenderer: (record: any) => (
        <Tooltip title={record.data.customAcrissLabel}>
          <span>{record.data.customAcrissLabel}</span>
        </Tooltip>
      ),
    },
    {
      field: "customAcrissKeyless",
      headerName: t("vehicleCategory.customAcrissKeyless"),
      flex: 1,
      cellRenderer: (record: any) => (
        
          <span>{changeNameAcrissKeyless(record.data.customAcrissKeyless) }</span> )
       
    },

    {
      field: "action",
      headerName: '',
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "edit-column",
      flex: 0.7,
      maxWidth:80,
      cellRenderer: (record: any) => (
        <Tooltip title={t("tooltipTitle.editShowAction")}>
          <IconButton className="edit-icon" size="small" aria-label="edit">
            <Edit fontSize="small" onClick={() => openMdalFncton(record)} />
          </IconButton>
        </Tooltip>
      ),
    },
  ];
   const changeNameAcrissKeyless = (params:String) => {
    switch (params) {
      case "true":
        return t("internOptionSelectName.yes")
      case "false":
        return t("internOptionSelectName.no")
      default:
        return "";
    }
   } 
  const handleChange = (event: any, type: any) => {
    setData({ ...dataForm, [type]: event.target.value });
  };
  const openMdalFncton = (record: any) => {
    setModalData(record.data);
    setOpenModal(true);
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  function managerData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        carSegmentOrder: !!element.carSegmentOrder
          ? element.carSegmentOrder
          : "",
        acrissMaxOverbooking: element.acrissMaxOverbooking,
        customAcrissAdditionalCreditCard:
          element.customAcrissAdditionalCreditCard,
        customAcrissAdditionalCreditCardTotal:
          element.customAcrissAdditionalCreditCardTotal,
        carSegmentDescr: element.carSegmentDescr,

        carClassDescr: !!element.carClassDescr ? element.carClassDescr : "",

        acrissCode: !!element.acrissCode ? element.acrissCode : "",

        acrissLabel: !!element.acrissLabel ? element.acrissLabel : "",

        acrissVehicleType: !!element.acrissVehicleType
          ? element.acrissVehicleType
          : "",

        customAcrissCode: !!element.customAcrissCode
          ? element.customAcrissCode
          : "",

        customAcrissLabel: !!element.customAcrissLabel
          ? element.customAcrissLabel
          : "",

        customAcrissKeyless: element.customAcrissKeyless?.toString() || "",

        id: !!element.customAcrissID ? element.customAcrissID : uuid(),

        customAcrissID: !!element.customAcrissID ? element.customAcrissID : "",

        acrissID: !!element.acrissID ? element.acrissID : "",
      };
      rows.push(row);
    });
    return rows;
  }

  const Search = () => {
    setIsLoading(true);
    return {
      
      getRows: async (serverSide: IServerSideGetRowsParams) => {
        const startRow = serverSide.request.startRow ? serverSide.request.startRow : 0;
        const endRow = serverSide.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;

        vehicleCategoriesActionss
          .getCarCompaniesQueryParams({ tenant,pageNumber, pageSize, ...params })
          .then((response: any) => {
            serverSide.successCallback(
              managerData(response),
              response.data.totalElements
            );
            setLength(response.data.totalElements);
            
            setIsLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
            setIsLoading(false);
          });
        //setIsLoading(false);
      },
    };
  };
  const SearchCategories = (e: any) => {
    e.preventDefault();
    setResetForm(!resetForm);
  };
  const reset = () => {

    setData({
      customAcrissCode: "",
      acrissCode: "",
      carClassDescription: "",
      carSegmentDescription: "",
    });
    setResetForm(!resetForm);
  };

  const updateVehicleCategories = (editVehicleObject: any) => {
    setIsLoading(true);
    vehicleCategoriesActionss
      .update(tenant,editVehicleObject)
      .then(() => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t("vehicleCategory.successMessage"),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });

        setIsLoading(false);
        setResetForm(!resetForm)
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.error,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setIsLoading(false);
        }
       
      });

    setOpenModal(false);
    //setResetForm(!resetForm);
  };

  function exportVehicleCategories() {
    setIsLoading(true);
    vehicleCategoriesActionss.exportData({tenant, ...params}).then((response: any) => {
      setIsLoading(false);
      const filename =
        response?.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      FileSaver.saveAs(blob, filename);
    });
  }

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(Search());
    }
  }, [gridApi, resetForm]);

  return (
    <Box>
      <SectionHeader
          title={t("vehicleCategory.titleFirst") + " " + t("vehicleCategory.titleSecond")}
      />
      <Box>
        <form
          id="idVehicleCategoriesForm"
          onSubmit={(e) => SearchCategories(e)}
        >
          <GenericFilterBox
            formId="idVehicleCategoriesForm"
            onReset={reset}
          >
         
            <Box>
              <TextField
                id="carSegment"
                name="carSegment"
                fullWidth
                //placeholder={t("vehicleCategory.searchAndFilter.carSegment")}
                label={t("vehicleCategory.searchAndFilter.carSegment")}
                value={dataForm.carSegmentDescription}
                onChange={(event: any) =>
                  handleChange(event, "carSegmentDescription")
                }
                variant="standard"
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>
            <Box>
              <TextField
                variant="standard"
                fullWidth
                id="carClass"
                name="carClass"
                // placeholder={t("vehicleCategory.searchAndFilter.carClass")}
                label={t("availabilityReport.carClassLabel")}
                value={dataForm.carClassDescription}
                onChange={(event: any) =>
                  handleChange(event, "carClassDescription")
                }
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                id="acriss"
                name="acriss"
                fullWidth
                //placeholder={t("vehicleCategory.searchAndFilter.arciss")}
                label={t("vehicleCategory.acrissCode")}
                value={dataForm.acrissCode}
                onChange={(event: any) => handleChange(event, "acrissCode")}
                variant="standard"
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                id="sipp"
                name="sipp"
                fullWidth
                //placeholder={t("vehicleCategory.searchAndFilter.sipp")}
                label={t("vehicleCategory.customAcrissCode")}
                value={dataForm.customAcrissCode}
                onChange={(event: any) =>
                  handleChange(event, "customAcrissCode")
                }
                variant="standard"
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event: any) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>
          </GenericFilterBox>
        </form>
      </Box>

      <Box className="carBrandOuterTableBox">
        <Box>
        <Card >
       
        
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
            <Tooltip  title={t("tooltipTitle.download")}>
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick={exportVehicleCategories}>
                <FileDownloadIcon/>
               </IconButton>
               </Tooltip>
          </Box>
         
        
        </Card>
        </Box>
        <Box>
          <AgGridOperationTable
            columnDefs={columns}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}

            />

          {loading && <CustomLoader loading={loading} />}
          {openModal && (
            <VehicleCategoriesModal
              closeModal={setOpenModal}
              initaliaValueVehicle={modalData}
              onUpdateVehicle={updateVehicleCategories}
              setResetForm={setResetForm}
              resetForm={resetForm}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default VehicleCategoriesTable;
